<template>
  <v-text-field
    label="Kilometer"
    min="0"
    type="number"
    :value="value"
    :hide-details="hideDetails"
    :disabled="disabled"
    :loading="loading"
    @input="onInput"
  />
</template>

<script>
export default {
  props: [
    'disabled',
    'hideDetails',
    'loading',
    'value',
  ],
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>
